import * as React from 'react';
import ReactDOM from "react-dom/client";
import LoadingSpinner from "./Loader/LoadingSpinner"

export const ModalWindow: React.FC<{
    isVisible: boolean,
    className?: string,
    logoClass?: string,
    children: React.ReactNode
}> = (props) => {

    const [modalIsVisible, setModalIsVisible] = React.useState(props.isVisible);

    let classInit = "micromodal";
    if (props.className) {
        classInit += " " + props.className;
    }

    let logoClass = "logo";
    if (props.logoClass) {
        logoClass = props.logoClass;
    }

    // Close Overlay and Drawer Modal when pressing 'Escape' button
    React.useEffect(() => {
        const closeModalWithEscapeBtn = (e: KeyboardEvent) => {
            if (modalIsVisible && e.code === "Escape") {
                setModalIsVisible(false);
            }
        };

        window.addEventListener("keydown", closeModalWithEscapeBtn);

        return () => {
            window.removeEventListener("keydown", closeModalWithEscapeBtn);
        }
    })

    return (
            <div className={classInit} aria-hidden="true">
                <div className="micromodal__overlay" tabIndex={-1} data-micromodal-close>
                    <div className="micromodal__container" role="dialog" aria-modal="true">
                        <div>
                            <div className="top-block">
                                <h1 className={logoClass}></h1>
                            </div>
                        <LoadingSpinner message="Checking Inventory..." fontSize={'2rem'} spinnerColor={"var(--loris-red)"}/>
                        </div>
                    </div>
                </div>
            </div>
    )
    
}


/**
 * Add modal screen for Lori's Marketplace
 */
export const popLorisMarketplaceLoader = (content?: string) => {

    if (!content) {
        content = "Checking Inventory ..."
    }

    const myDiv = document.createElement('div');
    document.body.appendChild(myDiv);

    const cartDrawerRoot = ReactDOM.createRoot(myDiv);
    cartDrawerRoot.render(
        <ModalWindow isVisible={true} className="fullscreen autoshow" logoClass="loris-marketplace-logo">
            {content}
        </ModalWindow>
    );


}
